export function setLowerCaseFirstLetter(data: TimApp.MarketConfiguration): TimApp.MarketConfiguration {
  const keyValues = Object.keys(data).map((key: string) => {
    const newKey = key === 'PSLS' ? key.toLowerCase() : key.charAt(0).toLowerCase() + key.slice(1);
    const newValue = key === 'PSLS' ? createPSLS(data[key]) : data[key];

    delete data[key];
    return { [newKey]: newValue };
  });
  return Object.assign(data, ...keyValues);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createPSLS(data: any): TimApp.PSLS {
  const psls: TimApp.PSLS = { suffix: { code: '', katashiki: '' } };
  if (data.Suffix && psls.suffix) {
    const { Code, Katashiki } = data.Suffix;
    if (Code) {
      psls.suffix.code = Code;
    }
    if (Katashiki) {
      psls.suffix.katashiki = Katashiki;
    }
  }
  return psls;
}
